export const toastStyles = (theme) => ({
  error: {
    "& *": {
      color: theme.palette.error.main,
    },
    border: `1px solid ${theme.palette.error.main}`,
    borderLeftWidth: 10,
  },
  warning: {
    "& *": {
      color: theme.palette.warning.main,
    },
    border: `1px solid ${theme.palette.warning.main}`,
    borderLeftWidth: 10,
  },
  success: {
    "& *": {
      color: theme.palette.success.main,
    },
    border: `1px solid ${theme.palette.success.main}`,
    borderLeftWidth: 10,
  },
});
